import { opportunityDetailsTransformer } from '@/features/opportunities/helpers';

import { Offer, OfferDetails } from '../types';

import { getColorFromOfferStatus } from './helpers';

export function offerDetailsTransformer(offer?: Offer): OfferDetails | null {
  if (!offer) return null;

  return {
    id: offer.id,
    status: {
      name: offer.status,
      color: getColorFromOfferStatus(offer.status),
    },
    opportunity: opportunityDetailsTransformer(offer.opportunity, []),
    company: {
      id: offer.company.id,
      name: offer.company.name,
    },
    createdAt: new Date(offer.created_at),
    buyerType: offer.buyer_type,
    buyerComments: offer.buyer_comments,
    buyerWebsite: offer.buyer_website,
    buyerPresentation: offer.buyer_presentation,
    file: offer.file,
    comments: offer.comments,
    rating: {
      comments: offer.rating_comments,
    },
    expressInterest: offer.express_interest,
    eoiFile: offer.eoi_file,
    availability: offer.availability,
    meetingTime: offer.meeting_time,
    transactionProgress: offer.transaction_progress,
    submittedEoiFile: offer.submitted_eoi_file,
    feedbackReject: offer.feedback_reject,
    internalNotesReject: offer.internal_notes_reject,
    manualScheduling: offer.request_manual_scheduling,
    manualSchedulingAvailability: offer.manual_scheduling_availability,
  };
}
